// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationCursor } from './PaginationCursor';
import {
    PaginationCursorFromJSON,
    PaginationCursorFromJSONTyped,
    PaginationCursorToJSON,
    PaginationCursorToJSONTyped,
} from './PaginationCursor';
import type { Trip } from './Trip';
import {
    TripFromJSON,
    TripFromJSONTyped,
    TripToJSON,
    TripToJSONTyped,
} from './Trip';

/**
 * Contains a list of Trip's matching the search-criteria.
 * @export
 * @interface TripResponse
 */
export interface TripResponse {
    /**
     * 
     * @type {Array<Trip>}
     * @memberof TripResponse
     */
    trips: Array<Trip>;
    /**
     * 
     * @type {PaginationCursor}
     * @memberof TripResponse
     * @deprecated
     */
    paginationCursor?: PaginationCursor;
    /**
     * Set for `v3/trips/{id}` only, otherwise set to null because irrelevant. **100% correctness cannot be guaranteed if `TripResponse::serviceProductAdapted` is true, do validate found `Trip` whether it might be what you are looking for!**
     * - If request parameter `retryFuzzy`=true or `strictness`=FUZZY and direct resolving of `Trip::id` failed and `ServiceProduct::number` tolerant re-search found an alternate match, this flag will be true.
     * - Otherwise if `retryFuzzy`=false or resolved initially by `id` this flag will be false.
     * @type {boolean}
     * @memberof TripResponse
     */
    serviceProductAdapted?: boolean;
}

/**
 * Check if a given object implements the TripResponse interface.
 */
export function instanceOfTripResponse(value: object): value is TripResponse {
    if (!('trips' in value) || value['trips'] === undefined) return false;
    return true;
}

export function TripResponseFromJSON(json: any): TripResponse {
    return TripResponseFromJSONTyped(json, false);
}

export function TripResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'trips': ((json['trips'] as Array<any>).map(TripFromJSON)),
        'paginationCursor': json['paginationCursor'] == null ? undefined : PaginationCursorFromJSON(json['paginationCursor']),
        'serviceProductAdapted': json['serviceProductAdapted'] == null ? undefined : json['serviceProductAdapted'],
    };
}

  export function TripResponseToJSON(json: any): TripResponse {
      return TripResponseToJSONTyped(json, false);
  }

  export function TripResponseToJSONTyped(value?: TripResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trips': ((value['trips'] as Array<any>).map(TripToJSON)),
        'paginationCursor': PaginationCursorToJSON(value['paginationCursor']),
        'serviceProductAdapted': value['serviceProductAdapted'],
    };
}

